const shirts = {
  areas: [
    {
      id: 1,
      slug: 'overall',
      name: '全体'
    },
    {
      id: 2,
      slug: 'body',
      name: '胴'
    },
    {
      id: 3,
      slug: 'collar',
      name: '襟ライン'
    },
    {
      id: 4,
      slug: 'arm',
      name: '腕'
    }
  ],
  parts: [
    {
      id: 1,
      slug: 'body_main',
      name: '胴',
      area_id: 2,
    },
    {
      id: 2,
      slug: 'body_side',
      name: '脇',
      area_id: 2,
    },
    {
      id: 3,
      slug: 'arm_shoulder_part',
      name: '肩パーツ',
      area_id: 4,
    },
    {
      id: 4,
      slug: 'arm_arm_part',
      name: '腕パーツ',
      area_id: 4,
    },
    {
      id: 5,
      slug: 'arm_sleeve_part',
      name: '袖パーツ',
      area_id: 4,
    },
    {
      id: 6,
      slug: 'arm_sleeve_line',
      name: '袖ライン',
      area_id: 4,
    },
  ],
  items: {
    overall: [
      {
        id: 1,
        slug: 'single_color',
        name: '単色',
      },
      {
        id: 2,
        slug: 'gradation',
        name: 'グラデーション',
      },
      {
        id: 3,
        slug: 'stripe',
        name: 'ストライプ',
      },
      {
        id: 4,
        slug: 'pattern',
        name: '柄',
      }
    ],
    body_main: [
      {
        id: 1,
        slug: 'body_main_1'
      },
      {
        id: 2,
        slug: 'body_main_2'
      },
      {
        id: 3,
        slug: 'body_main_3'
      },
      {
        id: 4,
        slug: 'body_main_4'
      },
    ],
    body_side: [
      {
        id: 1,
        slug: 'body_side_1',
        number_of_colors: 1,
      },
      {
        id: 2,
        slug: 'body_side_2',
        number_of_colors: 1,
      },
      {
        id: 3,
        slug: 'body_side_3',
        number_of_colors: 1,
      },
      {
        id: 4,
        slug: 'body_side_4',
        number_of_colors: 1,
      },
      {
        id: 5,
        slug: 'body_side_5',
        number_of_colors: 2,
      },
      {
        id: 6,
        slug: 'body_side_6',
        number_of_colors: 2,
      },
    ],
    collar: [
      {
        id: 1,
        slug: 'collar_1',
        number_of_colors: 1,
      },
      {
        id: 2,
        slug: 'collar_2',
        number_of_colors: 2,
      },
      {
        id: 3,
        slug: 'collar_3',
        number_of_colors: 3,
      },
      {
        id: 4,
        slug: 'collar_4',
        number_of_colors: 1,
      },
      {
        id: 5,
        slug: 'collar_5',
        number_of_colors: 1,
      },
    ],
    arm_shoulder_part: [
      {
        id: 1,
        slug: 'arm_shoulder_part_1'
      },
      {
        id: 2,
        slug: 'arm_shoulder_part_2'
      },
      {
        id: 3,
        slug: 'arm_shoulder_part_3'
      },
      {
        id: 4,
        slug: 'arm_shoulder_part_4'
      },
    ],
    arm_arm_part: [
      {
        id: 1,
        slug: 'arm_arm_part_1',
        number_of_colors: 1,
      },
      {
        id: 2,
        slug: 'arm_arm_part_2',
        number_of_colors: 2,
      },
      {
        id: 3,
        slug: 'arm_arm_part_3',
        number_of_colors: 2,
      },
      {
        id: 4,
        slug: 'arm_arm_part_4',
        number_of_colors: 2,
      },
      {
        id: 5,
        slug: 'arm_arm_part_5',
        number_of_colors: 2,
      },
    ],
    arm_sleeve_part: [
      {
        id: 1,
        slug: 'arm_sleeve_part_1',
        number_of_colors: 1,
      },
      {
        id: 2,
        slug: 'arm_sleeve_part_2',
        number_of_colors: 2,
      },
      {
        id: 3,
        slug: 'arm_sleeve_part_3',
        number_of_colors: 1,
      },
      {
        id: 4,
        slug: 'arm_sleeve_part_4',
        number_of_colors: 2,
      },
      {
        id: 5,
        slug: 'arm_sleeve_part_5',
        number_of_colors: 2,
      },
    ],
    arm_sleeve_line: [
      {
        id: 1,
        slug: 'arm_sleeve_line_1',
        number_of_colors: 1,
      },
      {
        id: 2,
        slug: 'arm_sleeve_line_2',
        number_of_colors: 2,
      },
      {
        id: 3,
        slug: 'arm_sleeve_line_3',
        number_of_colors: 3,
      },
      {
        id: 4,
        slug: 'arm_sleeve_line_4',
        number_of_colors: 1,
      },
      {
        id: 5,
        slug: 'arm_sleeve_line_5',
        number_of_colors: 3,
      },
    ],
  }
}
export default shirts